import { useContext } from 'react'
import { AuthContext } from 'src/@core/context/authContext'

export const useAuth = () => useContext(AuthContext)
